const METRIKA_ID = 110540676

type YmReachGoal = (
  counterId: number,
  method: "reachGoal",
  goal: string,
  params?: Record<string, unknown>,
) => void

declare global {
  interface Window {
    ym?: YmReachGoal
  }
}

export function reachGoal(goal: string, params?: Record<string, unknown>) {
  if (typeof window === "undefined") return
  const ym = window.ym
  if (typeof ym !== "function") return
  try {
    if (params) {
      ym(METRIKA_ID, "reachGoal", goal, params)
      return
    }
    ym(METRIKA_ID, "reachGoal", goal)
  } catch {
    // Счётчик мог ещё не загрузиться — цель просто не уходит.
  }
}
